module.exports = __webpack_public_path__ + "bd378accb7232a246150a060c48226cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_50.jpg
// module id = 1715
// module chunks = 5